/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function DarkFooter() {
  return (
    <footer className="footer">
      <Container>
        <nav>
          <div className="copyright" id="copyright">
            tel. 11.5816.7594  ventas@talali.com
          </div>
        </nav>
        <div className="copyright" id="copyright">
          ©Talali{" "}

        </div>
      </Container>
    </footer>
  );
}

export default DarkFooter;
